import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Seo from '../../components/Seo';
import { getStaticMeta } from '../../seo/pageMeta';

const TermsScreen = () => {
  const { t, i18n } = useTranslation();
  const meta = getStaticMeta('terms', i18n.language);

  return (
    <div className="min-h-screen bg-bg pt-28 pb-24 md:pt-32">
      <Seo title={meta.title} description={meta.description} path="/terms" />
      <div className="mx-auto max-w-page px-6">
        <article className="max-w-3xl mx-auto prose prose-invert prose-headings:text-body prose-a:text-primary prose-p:text-muted prose-li:text-muted">
          <h1>{t('legal.terms.title')}</h1>
          <p className="text-sm !text-muted">
            {t('legal.terms.lastUpdated')}
          </p>

          <section>
            <h2>{t('legal.terms.sections.presentation.title')}</h2>
            <p>{t('legal.terms.sections.presentation.content')}</p>
            <ul>
              {t('legal.terms.sections.presentation.parties', { returnObjects: true }).map((party, index) => (
                <li key={index}>{party}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2>{t('legal.terms.sections.object.title')}</h2>
            <p>{t('legal.terms.sections.object.content')}</p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.products.title')}</h2>
            <p>{t('legal.terms.sections.products.content')}</p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.prices.title')}</h2>
            <p>{t('legal.terms.sections.prices.content')}</p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.order.title')}</h2>
            <p>{t('legal.terms.sections.order.content')}</p>
            <ul>
              {t('legal.terms.sections.order.steps', { returnObjects: true }).map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ul>
            <p>{t('legal.terms.sections.order.confirmation')}</p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.payment.title')}</h2>
            <p>{t('legal.terms.sections.payment.content')}</p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.delivery.title')}</h2>
            <p>{t('legal.terms.sections.delivery.content')}</p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.withdrawal.title')}</h2>
            <p>{t('legal.terms.sections.withdrawal.content1')}</p>
            <p>{t('legal.terms.sections.withdrawal.content2')}</p>
            <p>{t('legal.terms.sections.withdrawal.content3')}</p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.warranties.title')}</h2>
            <p>{t('legal.terms.sections.warranties.content')}</p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.intellectualProperty.title')}</h2>
            <p>{t('legal.terms.sections.intellectualProperty.content1')}</p>
            <p>{t('legal.terms.sections.intellectualProperty.content2')}</p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.personalData.title')}</h2>
            <p>{t('legal.terms.sections.personalData.content1')}</p>
            <p>
              {t('legal.terms.sections.personalData.content2')}{' '}
              <Link to="/privacy">{t('legal.terms.sections.personalData.privacyLink')}</Link>.
            </p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.forceMajeure.title')}</h2>
            <p>{t('legal.terms.sections.forceMajeure.content')}</p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.law.title')}</h2>
            <p>{t('legal.terms.sections.law.content1')}</p>
            <p>{t('legal.terms.sections.law.content2')}</p>
          </section>

          <section>
            <h2>{t('legal.terms.sections.customerService.title')}</h2>
            <p>{t('legal.terms.sections.customerService.content')}</p>
            <ul>
              <li>{t('legal.terms.sections.customerService.email')}</li>
              <li>{t('legal.terms.sections.customerService.phone')}</li>
              <li>{t('legal.terms.sections.customerService.address')}</li>
            </ul>
          </section>
        </article>
      </div>
    </div>
  );
};

export default TermsScreen;
